/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from "react";

interface UseHeaderWidthSyncProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
  rows: any[];
  loading: boolean;
  width?: number;
}

export const useHeaderWidthSync = ({
  containerRef,
  rows,
  loading,
}: UseHeaderWidthSyncProps) => {
  const lastSyncedWidth = useRef<number>(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const syncHeaderWidth = () => {
      const tbody = el.querySelector(".tbody");
      const headerRow = el.querySelector(".full-screen-table .tr");
      if (tbody && headerRow) {
        const bodyFirstRow = tbody.querySelector(".tr");
        if (bodyFirstRow) {
          const bodyRowWidth = (bodyFirstRow as HTMLElement).scrollWidth;

          // Only update if width actually changed
          if (bodyRowWidth !== lastSyncedWidth.current) {
            lastSyncedWidth.current = bodyRowWidth;
            (headerRow as HTMLElement).style.minWidth = `${bodyRowWidth}px`;
          }
        }
      }
    };

    const timeoutId = setTimeout(syncHeaderWidth, 50);
    return () => clearTimeout(timeoutId);
  }, [containerRef, rows, loading]);
};
